import React from 'react'
import './Support_card.css'
import { Link } from 'react-router-dom'
import { IDS } from '../../../../utils/IDS'
import { encodeId } from '../../../../utils/common'

const Support_card = (props) => {
    return (
        <>
            <Link to={`/annadanam/${encodeId(props.id)}`}>
                <section className='Support_card_sec'>
                    <div className='imgdiv'>
                        <img className='supportimg' src={`${IDS.IMG_URL}${props?.image}`} alt="supportimg" />
                    </div>
                    <div className='overlayclr'></div>
                    <div className='overlaycontent'>
                        <h6 className='name'>{props.name}</h6>
                        <p className='content'>{props.subname}</p>
                    </div>
                </section>
            </Link>
        </>
    )
}

export default Support_card